export default {
    currentCategory :"Action",
    categories:[],
    movies:[],
    page:1,
    choosenMovie:[],
    topMovies:[],
    categorizedMovies:[],
    similarMovies:[]
}